export default "__VITE_ASSET__Bg9enH2C__"